@if (label) {
<span class="label">{{ label }}</span>
}
<input
    type="range"
    class="slider"
    [min]="min"
    [max]="max"
    [(ngModel)]="range"
    (ngModelChange)="rangeChanged()"
    [disabled]="disabled"
/>
<span class="range" [ngClass]="{'range--disabled': disabled}">{{ range }}</span>
